// recon-supplier-messages translations (Norwegian source catalog).
window.PlummeI18n.register('no', {
  'rcu.flag.old': 'Gammel post over 90 dager',
  'rcu.flag.overdue30': 'Forfalt over 30 dager',
  'rcu.flag.negative': 'Negativ leverandørsaldo',
  'rcu.flag.duplicate': 'Mulig duplikat',
  'rcu.flag.partlyPaidOpen': 'Delbetalt, fortsatt åpen',
  'rcu.flag.currency': 'Valutakurs må kontrolleres',
  'rcu.flag.missingDoc': 'Mangler bilag',
  'rcu.flag.paidAfter': 'Betalt etter periodedato',
  'rcu.age.noDue': 'Uten forfallsdato',
  'rcu.age.notDue': 'Ikke forfalt',
  'rcu.age.d1to30': '1–30 dager forfalt',
  'rcu.age.d31to60': '31–60 dager forfalt',
  'rcu.age.d61to90': '61–90 dager forfalt',
  'rcu.age.over90': 'Over 90 dager forfalt',
  'rcu.type.overpayment': 'Overbetaling',
  'rcu.type.invoice': 'Faktura',
  'rcu.unknownSupplier': 'Ukjent leverandør',
  'rcu.type.supplierCredit': 'Leverandørkredit',
  'rcu.type.importedInvoice': 'Importert faktura',
  'rcu.importedItem': 'Importert post',
  'rcu.check.ledgerVsSubledger': 'Hovedbok mot reskontro',
  'rcu.check.noControlAccount': 'Ingen kontrollkonto med reskontro i området',
  'rcu.check.old': 'Gamle poster over 90 dager',
  'rcu.check.overdue30': 'Forfalte poster over 30 dager',
  'rcu.check.negative': 'Negative leverandørsaldoer',
  'rcu.check.duplicates': 'Mulige duplikater',
  'rcu.check.paymentsNoInvoice': 'Betalinger uten faktura',
  'rcu.check.partlyPaidOpen': 'Delbetalt, men fortsatt åpen',
  'rcu.check.currencyItems': 'Valutaposter til kontroll',
  'rcu.check.directPostings': 'Direkteføringer på kontrollkonto',
  'rcu.check.missingDocs': 'Manglende bilag',
});
